import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import Subjects from '../../models/subjects';
import ITask from '../../models/task';
import DictionariesService from '../../services/dictionaries';
import { SaveTaskRequest, TaskService } from '../../services/task-service';
import ImageUploaderStore from '../common/image-uploader';
import SourceFilterStore from '../common/source-filter';
import TagsEditorStore from '../common/tags-editor';
import NumberInKimWithThemeStore from './number-in-kim-with-theme';
import TaskCloneStore from './task-clone';

export interface CreatedTask {
    source: string,
    theme: string,
    numberInKim: string,
    tags: string,
    answer: string
}

export default class NewTaskStore {

    taskService: TaskService;
    source: SourceFilterStore;
    numberInKimWithTheme: NumberInKimWithThemeStore;
    photoUploader: ImageUploaderStore;
    solutionUploader: ImageUploaderStore;
    dictionariesService: DictionariesService;
    subject: Subjects;

    tags: TagsEditorStore;
    text: string;
    answer: string;
    loading: boolean;
    step: number;
    id: number | null;
    savedTask: CreatedTask | null;

    taskClones: TaskCloneStore[] | null;

    constructor(subject: Subjects) {

        this.taskService = new TaskService();
        this.subject = subject;
        this.source = new SourceFilterStore(subject, false);
        this.numberInKimWithTheme = new NumberInKimWithThemeStore(subject);
        this.tags = new TagsEditorStore();
        this.text = "";
        this.answer = "";
        this.step = 0;
        this.id = null;
        this.savedTask = null;
        this.loading = false;
        this.photoUploader = new ImageUploaderStore(subject, true);
        this.solutionUploader = new ImageUploaderStore(subject, false);
        this.dictionariesService = new DictionariesService();
        this.taskClones = null;

        makeAutoObservable(this);
    }

    changeText(value: string): void {
        this.text = value;
    }

    changeAnswer(value: string): void {
        this.answer = value;
    }

    changeStep(step: number): void {
        this.step = step;
    }

    reset(): void {
        this.text = "";
        this.answer = "";
        this.step = 0;
        this.id = null;
        this.savedTask = null;
        this.loading = false;
        this.tags.reset();
        this.source.reset();
        this.numberInKimWithTheme.reset();
        this.photoUploader.reset();
        this.solutionUploader.reset();
        this.taskClones = null;
    }

    createTask = async () => {

        this.loading = true;

        try {
            const params: SaveTaskRequest = {
                source: this.source.selectedItemAsNumber,
                numberInKim: this.numberInKimWithTheme.numberInKim.selectedItemAsNumber,
                theme: this.numberInKimWithTheme.theme.selectedItemAsNumber,
                tags: this.tags.getTags,
                answer: this.answer
            };

            this.savedTask = {
                source: this.source.selectedItemValue,
                numberInKim: this.numberInKimWithTheme.numberInKim.selectedItemValue,
                theme: this.numberInKimWithTheme.theme.selectedItemValue,
                tags: this.tags.tagsAsString,
                answer: this.answer
            };

            this.taskService.create(
                this.subject,
                params,
                (data: any) => {

                    if (data && data['id']) {
                        this.id = data['id'];
                        this.photoUploader.setTaskId(data['id']);
                        this.solutionUploader.setTaskId(data['id']);
                    }

                    this.loading = false;
                }, (error: string) => {
                    this.loading = false;
                    message.error(`Ошибка при создании задачи: ${error}`);
                }
            );

        } catch (error) {
            runInAction(() => {
                this.loading = false;
                message.error(`Ошибка при создании задачи: ${error}`);
            });
        }
    }

    loadClones(): void {

        if (this.id) {

            this.loading = true;

            this.taskService.getPossiblyClones(this.id, (data: any) => {
                this.taskClones = (data['content'] as ITask[]).map(item => new TaskCloneStore(item, this.id, this.taskService));
                this.loading = false;
            }, (_) => this.loading = false);
        }
    }
}